import React from 'react';

import { Checkbox } from 'cpool-components/input/Checkbox';

import TreatButton from '~/components/TreatButton';
import { ReactComponent as DeleteIcon } from '~/features/leadDetails/assets/delete-icon.svg';
import type { SchemaDemandedDocumentsKeys } from '~/features/leadDetails/schemas/demandedDocuments.schema';

type Props = {
    document: string;
    requested: boolean;
    update: (path: SchemaDemandedDocumentsKeys, name: string, requested: boolean) => void;
    remove: (path: SchemaDemandedDocumentsKeys, name: string) => void;
};

const IndividualDocumentEntry: React.FC<Props> = ({ document, remove, requested, update }) => {
    return (
        <div className="flex items-center justify-between gap-2">
            <Checkbox
                id={`individualDocuments-${document}`}
                name={document}
                label={document}
                checked={requested}
                onChange={(e) => update('individualDocuments', document, e.target.checked)}
            />
            <TreatButton onClick={() => remove('individualDocuments', document)}>
                <DeleteIcon />
            </TreatButton>
        </div>
    );
};

export default IndividualDocumentEntry;
